/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Rajesh's Portfolio",
  description:
    "A passionate individual who always thrives to work on end to end products which develop sustainable and scalable social and technical systems to create impact.",
  og: {
    title: "Rajesh Portfolio",
    type: "website",
    url: "https://rajesh9943.github.io",
  },
};

//Home Page
const greeting = {
  title: "Hey There",
  logo_name: "Rajesh",
  nickname:"I'm Rajesh",
  subTitle:"A passionate individual who always thrives to work on end to end products which develop sustainable and scalable social and technical systems to create impact.",
  resumeLink:
    "https://drive.google.com/file/d/1kNIkdHNQtJvUnAiUbHg0Sb1DJVh-JzVQ/view?usp=sharing",
  portfolio_repository: "https://drive.google.com/file/d/1kNIkdHNQtJvUnAiUbHg0Sb1DJVh-JzVQ/view?usp=sharing",
  githubProfile: "https://github.com/Rajesh-A1",
};


const socialMediaLinks = [
  /* Your Social Media Link */
  // github: "https://github.com/Rajesh9943",
  // linkedin: "https://www.linkedin.com/in/a-rajesh/",
  // gmail: "https://mail.google.com/mail/u/0/?fs=1&to=rajeshpandiyan1110@gmail.com&tf=cm",
  // instagram: "https://www.instagram.com/therajesh.a/"

  {
    name: "Github",
    link: "https://github.com/Rajesh9943",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/a-rajesh/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },

  {
    name: "Gmail",
    link: "mailto:rajeshalagupandiyan@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },

  {
    name: "Instagram",
    link: "https://www.instagram.com/therajesh.a/",
    fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/instagram?style=brands
    backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
  },

  {
    name: "Whatsapp",
    link: "https://wa.me/+919943326068",
    fontAwesomeIcon: "fa-brands fa-whatsapp", // Reference https://fontawesome.com/icons/instagram?style=brands
    backgroundColor: "#25D366", // Reference https://simpleicons.org/?q=instagram
  },
];

const skills = {
  data: [
    {
      title: "Data Science & AI",
      fileName: "DataScienceImg",
      skills: [
        "CRAZY DATA SCIENCE PROGRAMMER APPLYING COOL INNOVATIVE IDEAS",
        "⚡ Passionate about leveraging data to solve real-world problems and continuously learning new tools and techniques in the field.",
        "⚡ Developing highly scalable production ready models for various deeplearning and statistical use cases",
        "⚡ With expertise in Python, SQL, R, and advanced data visualization techniques, I aim to uncover insights and drive informed decision-making to benefit both social and technical systems.",
        "⚡ Complex quantitative modelling for dynamic forecasting and time series analysis",
        
      ],
      softwareSkills: [
        {
          skillName: "Python",
          fontAwesomeClassname: "logos:python",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "R",
          fontAwesomeClassname: "devicon:r",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Sql",
          fontAwesomeClassname: "devicon-plain:sqldeveloper",
          style: {
            backgroundColor: "transparent",
            style:"color: #3498db;",
            color: "#3498DB",
          },
        },
        {
          skillName: "Excel",
          fontAwesomeClassname: "vscode-icons:file-type-excel",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
        skillName: "Tableau",
        fontAwesomeClassname: "logos:tableau",
        },
        {
          skillName: "Power BI",
          fontAwesomeClassname: "logos:microsoft-power-bi",
          style: {
            backgroundColor: "transparent",
            style:"color: #3498db;",
            color: "#3498DB",
            },
          },
        {
          skillName: "Github",
          fontAwesomeClassname: "devicon:github",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "jupyter",
          fontAwesomeClassname: "logos:jupyter",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Pandas",
          fontAwesomeClassname: "logos:pandas-icon",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Tensorflow",
          fontAwesomeClassname: "logos-tensorflow",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Keras",
          fontAwesomeClassname: "simple-icons:keras",
          style: {
            backgroundColor: "white",
            color: "#D00000",
          },
        },
        {
          skillName: "PyTorch",
          fontAwesomeClassname: "logos-pytorch",
          style: {
            backgroundColor: "transparent",
          },
        },
      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "LeetCode",
      iconifyClassname: "simple-icons:leetcode",
      style: {
        color: "#FFA116",
      },
      profileLink: "https://leetcode.com/a_rajesh/",
    },
    {
      siteName: "GeeksforGeeks",
      iconifyClassname: "simple-icons:geeksforgeeks",
      style: {
        color: "#2F8D46",
      },
      profileLink: "https://auth.geeksforgeeks.org/user/rajesh1110",
    },
    {
      siteName: "HackerRank",
      iconifyClassname: "simple-icons:hackerrank",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://www.hackerrank.com/a_rajesh",
    },
    {
      siteName: "Kaggle",
      iconifyClassname: "simple-icons:kaggle",
      style: {
        color: "#20BEFF",
      },
      profileLink: "https://www.kaggle.com/rajesh1110",
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Oxford Engineering College,Trichy",
      subtitle: "B.Tech in Information Technology",
      logo_path: "oec.logo.png",
      alt_name: "OEC Trichy",
      duration: "2020 - 2024",
      descriptions: [
        "⚡ I have studied basic software engineering subjects like DS, Algorithms, DBMS, OS, CA, AI, WT, etc.",
        "⚡ Apart from this, I have done courses on Python, SQL, Data Scince, Bigdata, Machine Learning 101 and Advanced Google Analytics.",
      ],
      website_link: "http://oxfordec.edu.in/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Data Analytics Internship",
      subtitle: "- Prepinsta",
      logo_path: "Data_Analytics_Internship.jpg",
      certificate_link:
        "https://drive.google.com/file/d/1uy20NoiclnkzvaF34BTTk_4X2Me2OJPe/view?usp=sharing",
      alt_name: "Data Analytics Internship",
      color_code: "#c3def1",
    },
    {
      title: "Machine Learning & Deep Learning with Data Science Short Term Training Programme ",
      subtitle: "- Care College of Engineering",
      logo_path: "79c231c1-4f16-435b-b04d-374ca800cca8_page-0001.jpg",
      certificate_link:"https://credsverse.com/credentials/79c231c1-4f16-435b-b04d-374ca800cca8",
      alt_name: "Short Term Training Programme",
      color_code: "#F5F5F5",
    },
    {
      title: "Python Programming",
      subtitle: "- M.Arunprakash",
      logo_path: "guvi.png",
      certificate_link:"https://www.guvi.in/verify-certificate?id=3kI1897Q4f6hY60051",
      alt_name: "Guvi",
      color_code: "#F7F9F9",
    },
    {
      title: "Introduction to Data Science by VISA",
      subtitle: "MIT Workshop - Kritika ",
      logo_path: "visalogo.png",
      certificate_link:"https://drive.google.com/file/d/1Py-n-HnRo6vet-N4pKOmesHL4Bpe4CJg/view?usp=sharing",
      alt_name: "MIT Workshop",
      color_code: "#F7F9F9",
    },
    {
      title: "Introduction to Data Science",
      subtitle: "- Lavanya Vijayan and Madecraft",
      logo_path: "1lll.png",
      certificate_link:"https://www.linkedin.com/learning/certificates/982df9c271b720c2f8a9ef009f4e01a2a511fc0c8d6b013a71bcf64f825ddbb6",
      alt_name: "LinkedInLearning",
      color_code: "#F7F9F9",
    },
    {
      title: "Become a Data Scientist",
      subtitle: "- Jungwoo Ryoo, Barton Poulson, Eddie Davila, Bill Shander, Jonathan Reichental",
      logo_path: "LinkedInLearningLogo.png",
      certificate_link:
        "https://www.linkedin.com/learning/paths/become-a-data-scientist?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_certifications_details%3Bt3i6T5wASkmE%2FM4pxqFzdg%3D%3D",
      alt_name: "LinkedInLearning",
      color_code: "#0174b1",
    },
    {
      title: "Master SQL for Data Science",
      subtitle: "- Bill Weinman, Scott Simpson, Emma Saunders, Dan Sullivan, Ben Sullins",
      logo_path: "1lll.png",
      certificate_link:"https://drive.google.com/file/d/1kDzkM4OeyBLywYxC6uYbuHFQvIjyPbcf/view?usp=sharing",
      alt_name: "LinkedInLearning",
      color_code: "#34345E",
    },
    {
      title: "Advanced Google Analytics",
      subtitle: "- Madecraft and Brad Batesole",
      logo_path: "1lll.png",
      certificate_link:
        "https://drive.google.com/file/d/1uJ__jBJp5m5PYIaqFy82b-vP_PdZya_E/view?usp=sharing",
      alt_name: "LinkedInLearning",
      color_code: "#F7F9F9",
    },
    {
      title: "Statistics Foundations: Probability",
      subtitle: "- Eddie Davila",
      logo_path: "1lll.png",
      certificate_link:
        "https://www.linkedin.com/learning/certificates/52bc95c78fac7a02ca51a77717f23da6607b7d9ca8987f811192f302583d6d3d?trk=share_certificate&lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_certifications_details%3BeAV6x3qwQMab2LMvLZtcow%3D%3D",
      alt_name: "LinkedInLearning",
      color_code: "#34495E",
    },

  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work, Internship and Volunteership",
  description:
    "To immerse myself in the dynamic world of data analysis, honing my skills and contributing to impactful projects. Throughout my Work, I leveraged a diverse array of tools and techniques to collect, clean, and manipulate data, ensuring its quality and relevance for analysis.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Internships",
      experiences: [
        
        {
          title: "Data Analyst Intern",
          company: "Prepinsta, ( View credential )",
          company_url: "https://drive.google.com/file/d/1uy20NoiclnkzvaF34BTTk_4X2Me2OJPe/view?usp=sharing",
          logo_path: "prep.png",
          duration: "25/11/2023 - 25/11/2024",
          location: "Noida, Uttar Pradesh",
          description:"Interpreted the data to discover valuable insights and trends that aided decision-making processes. I worked on multiple projects involving data analysis, visualization, and reporting, developing visualized dashboards to effectively communicate complex data insights derived from the analysis.",
          color: "#117864",
        },
      ],
    },
    {
      title: "Short Term Training Programme",
      experiences: [
        
        {
          title: "Machine Learning & Deep learning with Data science",
          company: "CARE College of Engineering, ( View credential )",
          company_url: "https://drive.google.com/file/d/1kEV9xipmkHecosg1lqdQhsvHSnE_cKRk/view?usp=sharing",
          logo_path: "careschoolofengineering_logo.jpeg",
          duration: "17/07/2023 - 21/07/2023",
          location: "Trichy, Tamil Nadu",
          description:"Enriched my knowledge in Machine Learning (ML) & Deep Learning (DL) Programming Languages: Python, R, SQL / Data Visualization: Matplotlib, Seaborn, ggplot2, Tableau / Machine Learning Libraries: TensorFlow, Scikit-learn, Keras / Big Data Technologies: Hadoop, Spark, Hive / Data Manipulation and Analysis: Pandas, NumPy, dplyr / Cloud Platforms: AWS, Google Cloud Platform, Azure / NLP: NLTK, SpaCy / Deep Learning Frameworks: PyTorch, TensorFlow.keras through the STTP at CARE College of Engineering. Particularly interested in Supervised, Unsupervised & Reinforcement Learning.",
          color: "#117864",
        },
      ],
    },
    {
      title: "Workshops",
      work: true,
      experiences: [
                
        {
          title: "Introduction of Data Science",
          company: "Madras Institute of Technology, ( View credential )",
          company_url: "https://drive.google.com/file/d/1Py-n-HnRo6vet-N4pKOmesHL4Bpe4CJg/view?usp=sharing",
          logo_path: "visalogo.png",
          duration: "14 May 2022",
          location: "Chennai, Tamil Nadu",
          description:"CARTE BLANCHE '22 workshop conducted by the Computer Society of MIT at the Madras Institute of Technology. This workshop significantly enhanced my knowledge in the field of Programming Languages, Data Visualization, Machine Learning Libraries, Big Data Technologies, Data Manipulation and Analysis, Cloud Platforms, NaturalLanguage Processing, Deep Learning Frameworks providing me with valuable insights into methodologies and tools used in data science.",
          color: "#C0392B",
        },
        {
          title: "Artificial intelligence & Internet of Things",
          company: "Anna University, (View credential )",
          company_url: "https://drive.google.com/file/d/1DdBfA82TQTrSyEfgJlnl-exViV2qf74g/view?usp=sharing",
          logo_path: "au.trichy.png",
          duration: "27 March 2023",
          location: "Trichy, Tamil Nadu",
          description:"A National level technical symposium on Artificial Intelligence, Machine Learning, Natural Language Processing, and the Internet of Things was hosted by the Department of Computer Science and Engineering (CSE). Led by experienced experts, the interactive workshop provided participants with hands-on experience and valuable insights into the latest industry trends. ",
          color: "#3498DB",
        },
      ],
    },

    {
      title: "Volunteerships",
      experiences: [
        {
          title: "Management Facilitator",
          company: "Chennai Data Circle",
          company_url: "https://www.linkedin.com/company/chennai-data-circle/",
          logo_path: "chennai_data_circle_logo.jpeg",
          duration: " January 2024 - Present",
          location: "Chennai, Tamil Nadu",
          description:"Through Chennai networking events, Chennai Data Circle (CDC) fosters a vibrant community by bridging the gap between data professionals and enthusiasts. By bringing data minds together for in-person events and discussions, CDC builds a strong Chennai data network.",
          color: "#4285F4",
        },
        {
          title: "Program Director",
          company: "National Service Scheme",
          company_url: "",
          logo_path: "nss-auxilium-no-bg.png",
          duration: "June 2018 - March 2020",
          location: "Pudukkottai, Tamil Nadu",
          description:"I lead and manage a dedicated group of individuals passionate about making a positive impact through social service. We organize and oversee various initiatives and projects that achieve multiple goals: promoting social awareness, instilling a sense of responsibility, and encouraging volunteerism. By fostering teamwork, promoting leadership, and facilitating personal growth, we empower our group to achieve these goals.",
          color: "#D83B01",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects makes use of vast variety of latest technology tools. My best experience is to create Data Science projects and deploy them to web applications using cloud infrastructure.",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {
  title: "Publications",
  description: "Some of my published Articles, Blogs and Research.",
  avatar_image_path: "projects_image.svg",
};

const publications = {
  data: [
    {
      id: "neuro-symbolic-sudoku-solver",
      name: "Neuro-Symbolic Sudoku Solver",
      createdAt: "2023-07-02T00:00:00Z",
      description: "Paper published in KDD KiML 2023",
      url: "https://arxiv.org/abs/2307.00653",
    },
    {
      id: "mdp-diffusion",
      name: "MDP-Diffusion",
      createdAt: "2023-09-19T00:00:00Z",
      description: "Blog published in Paperspace",
      url: "https://blog.paperspace.com/mdp-diffusion/",
    },
    {
      id: "consistency-models",
      name: "Consistency Models",
      createdAt: "2023-10-12T00:00:00Z",
      description: "Blog published in Paperspace",
      url: "https://blog.paperspace.com/consistency-models/",
    },
  ],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "Rajesh_Pic.png",
    description:
      " I specialize in data wrangling, visualization, and statistical analysis, with a strong proficiency in Python, SQL, and R. I can assist with Machine Learning, AI, and data-driven projects. Feel free to reach out to me on LinkedIn or through my portfolio. I respond within 24 hours and am eager to collaborate on your next big data or tech project..",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "I like to document some of my experiences in professional career journey as well as some technical knowledge sharing.",
    link: "https://blogs.ashutoshhathidara.com/",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Address",
    subtitle: "Kallupatti, Viralimalai, Pudukkottai, Tamil Nadu 621316",
    locality: "Viralimalai",
    country: "India",
    region: "Tamil Nadu",
    postalCode: "621 316",
    streetAddress: "Saratoga Avenue",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://maps.app.goo.gl/QFXWNMqJURYXtaki6",
  },
  phoneSection: {
    title: "",
    subtitle: "",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  publications,
  contactPageData,
};
